import React from 'react';

interface LinkProps {
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
}

export const Link: React.FC<LinkProps> = ({ href, children, onClick }) => {
  return (
    <a 
      href={href} 
      onClick={onClick}
      className="text-white hover:text-teal-400 font-medium transition-colors duration-300"
    >
      {children}
    </a>
  );
};